export function setBtnAreaConfig() {
  return [
    {label: ()=> {return '搜索'}, type: 'primary', bindClick: ()=>{this.getListCX()}, setPower: () => {return true}},
    {label: ()=> {return '重置'}, type: 'primary', bindClick: ()=>{this.resetForm('filters')}, setPower: () => {return true}},
    {label: ()=> {return '新增'}, type: 'primary', bindClick: ()=>{this.goForm('add')}, setPower: () => {return true}},
  ]
}
export function setTableConfig() {
	return {
    label: ['Sink名称', 'Sink类型', '状态', '创建时间', '创建人', '操作'],
    prop: ['name', 'sinkType', 'usedStatus', 'createTime', 'creatorName','active'],
    custom: [
      {
        prop: 'usedStatus',
        width: 80
      },
      {
        prop: 'usedStatus',
        customType: 'custom-dom',
        customRender: (scope) => {
          return scope.row.usedStatus == "Y" ? '占用' : '未占用'
        }
      },
      {
        prop: 'createTime',
        width: 170,
        customType: 'custom-dom',
        customRender: (scope) => {
          return `<div>${scope.row.createTime.replace(/T/g,' ')}</div>`
        }
      },
      {
        prop: 'active',
        customType: 'table-btn',
        customBtnList: [
          {
            render: () => { if(this.tableData.length > 0) return '详情' },
            customBindClick: (scope) => {this.goForm('details',scope.row.id,scope.row.sinkType)}
          },
          {
            render: () => '修改',
            customBindClick: (scope) => {this.goForm('edit',scope.row.id,scope.row.sinkType)}
          },
          {
            getStyle: (scope) => {return scope.row.usedStatus == 'Y' ? {color: '#787a7f'} : null},
            render: () => '删除',
            customBindClick: (scope) => {if(scope.row.usedStatus == 'N') this.del(scope.row.id,scope.row.sinkType)}
          }
        ]
      },
    ]
  }
}
